import type { ReactNode } from "react"

import Back from "./Back"

type PageHeadingProps = {
  children: ReactNode
}

export default function PageHeading({ children }: PageHeadingProps) {
  return (
    <div className="mb-section flex w-full flex-col-reverse items-start gap-paragraph md:flex-row md:items-center md:justify-between">
      <h1>{children}</h1>
      <Back />
    </div>
  )
}
